module.exports = __webpack_public_path__ + "static/media/Azure_contentsPage_ko.b55efab8.png";